"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var il_icon_common_1 = require("../il-icon/il-icon.common");
var solid_icon_definitions_1 = require("../il-icon/solid-icon-definitions");
var enums_1 = require("../../shared/enums");
function ILSideNavigation(_a) {
    var children = _a.children, toolbar = _a.toolbar, _b = _a.drawerWidth, drawerWidth = _b === void 0 ? 240 : _b, _c = _a.anchor, anchor = _c === void 0 ? enums_1.AnchorEnum.LEFT : _c, navItems = _a.navItems, sx = _a.sx, container = _a.container, drawerToolbar = _a.drawerToolbar, _d = _a.toolbarColor, toolbarColor = _d === void 0 ? 'primary' : _d, menuIconColor = _a.menuIconColor, props = __rest(_a, ["children", "toolbar", "drawerWidth", "anchor", "navItems", "sx", "container", "drawerToolbar", "toolbarColor", "menuIconColor"]);
    var isRightAnchor = anchor === enums_1.AnchorEnum.RIGHT;
    var classes = 'il-side-navigation ' + (props.className || '');
    var _e = react_1.default.useState(false), open = _e[0], setOpen = _e[1];
    function toggleDrawer() {
        setOpen(!open);
    }
    function renderNavigationItems() {
        if (navItems && Array.isArray(navItems)) {
            return (react_1.default.createElement(material_1.List, null,
                react_1.default.createElement(material_1.Toolbar, null, drawerToolbar),
                react_1.default.createElement(material_1.Divider, null),
                navItems.map(function (nav, idx) {
                    var key = nav.key || idx;
                    if (nav.divider) {
                        return react_1.default.createElement(material_1.Divider, { key: key }, nav.primaryText);
                    }
                    return (react_1.default.createElement(material_1.ListItem, { disablePadding: true, key: key, "aria-label": "menuitem ".concat(nav.primaryText) },
                        react_1.default.createElement(material_1.ListItemButton, { onClick: nav.onClick },
                            nav.icon && react_1.default.createElement(material_1.ListItemIcon, null, nav.icon),
                            react_1.default.createElement(material_1.ListItemText, { primary: nav.primaryText, secondary: nav.secondaryText }))));
                })));
        }
        return navItems;
    }
    return (react_1.default.createElement(material_1.Box, { sx: __assign({ display: 'flex' }, sx), className: classes },
        react_1.default.createElement(material_1.CssBaseline, null),
        react_1.default.createElement(material_1.AppBar, { position: "fixed", sx: {
                width: { lg: "calc(100% - ".concat(isRightAnchor ? 0 : drawerWidth, "px)") },
                ml: { lg: drawerWidth },
                backgroundColor: toolbarColor,
            } },
            react_1.default.createElement(material_1.Toolbar, { sx: {
                    backgroundColor: toolbarColor,
                } },
                react_1.default.createElement(material_1.IconButton, { color: "inherit", "aria-label": "open drawer", edge: "start", onClick: toggleDrawer, sx: {
                        mr: 2,
                        display: { md: 'block', lg: 'none' },
                    } },
                    react_1.default.createElement(il_icon_common_1.SolidIcon, { sx: {
                            color: menuIconColor || 'primary.contrastText',
                        }, icon: solid_icon_definitions_1.SolidIconDefinitions.MENU })),
                toolbar)),
        react_1.default.createElement(material_1.Box, { component: "nav", sx: {
                width: { lg: isRightAnchor ? 0 : drawerWidth },
                flexShrink: { lg: 0 },
                '& .MuiPaper-root': { backgroundColor: 'background.default' },
            }, "aria-label": "folders" },
            react_1.default.createElement(material_1.Drawer, { container: container, variant: "temporary", open: open, anchor: anchor, onClose: toggleDrawer, ModalProps: {
                    keepMounted: true, // Better open performance on mobile.
                }, sx: {
                    display: { md: 'block', lg: 'none' },
                    backgroundColor: 'background.default',
                    '& .MuiDrawer-paper': {
                        boxSizing: 'border-box',
                        width: drawerWidth,
                    },
                } }, renderNavigationItems()),
            react_1.default.createElement(material_1.Drawer, { variant: "permanent", container: container, anchor: anchor, sx: {
                    display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' },
                    '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                }, open: true }, renderNavigationItems())),
        children));
}
exports.default = ILSideNavigation;
